// All user-visible strings (Thai). Only the h1, the #beta chip, #about and the lang="en" paragraph live in index.html.
// Every control reads its label/copy from here — never a hardcoded Thai literal in main.js.
const S = {
  styleGroup: "แบบที่รองแก้ว",
  styles: {
    two: "สองหน้า",
    logo: "ชื่อ / โลโก้",
  },
  titles: {
    two: "ที่รองแก้วสองหน้า",
    logo: "ที่รองแก้วใส่โลโก้",
  },
  textHint: (lines, chars) => `ได้ถึง ${lines} บรรทัด บรรทัดละไม่เกิน ${chars} ตัวอักษร`,
  needFile: "เลือกไฟล์ SVG ของโลโก้ — ไฟล์อยู่ในเครื่องของคุณ ไม่ถูกส่งไปที่ใด",
  artKept: "โลโก้อยู่ในหน้านี้เท่านั้น — รีเฟรชหน้าแล้วต้องเลือกไฟล์ใหม่",
  keptOld: "(ยังใช้โลโก้เดิมอยู่)",
  thumb: "ตัวอย่างโลโก้ที่อ่านได้",
  finish: "แบบโลโก้",
  finishes: {
    flush: "เรียบ",
    raised: "นูน",
    engraved: "เซาะร่อง",
  },
  finishNote: {
    flush: "เรียบเสมอผิว โลโก้เป็นอีกสีหนึ่ง ต้องใช้เครื่องพิมพ์หลายสีและไฟล์ 3MF (ไฟล์ STL ไม่มีโลโก้ จึงปิดไว้)",
    raised: (mm) => `นูนขึ้น ${mm} มม. เครื่องหัวเดียวก็ได้สองสี เปลี่ยนสีครั้งเดียว (เลือก “หัวเดียว” ที่วิธีพิมพ์) แก้ววางบนตัวนูน อาจโยกได้ถ้าโลโก้แคบ`,
    engraved: (mm) => `เซาะร่องลึก ${mm} มม. ใช้สีเดียว ไม่ต้องเปลี่ยนเส้น`,
  },
  flushNeedsMulti: "แบบเรียบพิมพ์ด้วยหัวเดียวไม่ได้ ต้องเลือกวิธีพิมพ์หลายสี",
  scale: "ขนาดโลโก้",
  logoColour: "สีโลโก้",
  logoPartNames: {
    body: "ตัวที่รองแก้ว",
    message: "โลโก้",
  },
  logoZNames: {
    body: "สีตัว",
    message: "สีโลโก้",
  },
  logoEdgeNote: {
    lip: (mm) => `ขอบสูงกว่าหน้าที่รองแก้ว ${mm} มม. กันน้ำไหลออก`,
    flat: "ไม่มีขอบ หน้าเรียบเสมอกัน",
  },
  gShape: "รูปทรงและขอบ",
  gColour: "สีและการพิมพ์",
  a: "คำฝั่ง A",
  b: "คำฝั่ง B",
  wordHint: "ฝั่ง B คือคนที่นั่งตรงข้าม คำสั้นอ่านง่ายที่สุด ไม่เกิน 6 ตัวอักษรกำลังดี",
  rows: (n) => `${Math.floor(n)} เส้น`,
  shape: "รูปทรง",
  shapes: {
    round: "กลม",
    square: "สี่เหลี่ยม",
  },
  views: {
    a: "ฝั่ง A",
    b: "ฝั่ง B",
    top: "มองจากบน",
  },
  d: {
    round: "เส้นผ่านศูนย์กลาง",
    square: "ความกว้าง",
  },
  mm: (v) => `${v} มม.`,
  edge: "ขอบ",
  edges: {
    lip: "ขอบยกกันน้ำ",
    flat: "ขอบเรียบ",
  },
  edgeNote: {
    lip: "ขอบสูงกว่าสันนูน 1.2 มม. กันน้ำไหลออก",
    flat: "ขอบเสมอสันนูน น้ำอยู่ในร่อง",
  },
  looks: "ธีมสี",
  lookNames: {
    night: "กลางคืน",
    bee: "ดำเหลือง",
    wood: "ไม้",
  },
  colour: {
    body: "สีตัวที่รองแก้ว",
    message: "สีข้อความ",
  },
  mode: "วิธีพิมพ์",
  modes: {
    multi: "หลายสี (CFS / AMS)",
    swap: "หัวเดียว เปลี่ยนสีตามชั้น",
  },
  modeNote: {
    multi: "ไฟล์ 3MF มี 2 ชิ้นส่วน ตั้งสีให้แต่ละชิ้นในโปรแกรม slicer",
    swap: (z1, z2) => `พิมพ์ที่ความสูงชั้น 0.2 มม. สั่งหยุดเปลี่ยนเส้นก่อนชั้นที่แสดงใต้ภาพ (สีเปลี่ยนที่ความสูง ${z1} และ ${z2} มม. ของชิ้นงาน)`,
    swapOne: (layer, z) => `พิมพ์ที่ความสูงชั้น ${layer} มม. สั่งหยุดเปลี่ยนเส้นก่อนชั้นที่แสดงใต้ภาพ (สีเปลี่ยนที่ความสูง ${z} มม. ของชิ้นงาน)`,
    lipToo: "ขอบยกจะเป็นสีโลโก้ด้วย",
    oneColour: "พิมพ์สีเดียว ไม่ต้องตั้งค่าเปลี่ยนสี",
  },
  zLine: (layer, filament, name) => `ก่อนชั้นที่ ${layer} ใช้ ${filament} (${name})`,
  partNames: {
    body: "ตัวที่รองแก้ว",
    message: "ข้อความ",
  },
  zNames: {
    body: "สีตัว",
    message: "สีข้อความ",
  },
  size: (shape, d, h) => (shape === 'round' ? `Ø ${d} × ${h} มม.` : `${d} × ${d} × ${h} มม.`),
  hold: (ml) => `รับน้ำได้ประมาณ ${Math.round(ml)} มล.`,
  loadingFont: (family, got, total) => (total > 0 ? `กำลังโหลด ${family} ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `กำลังโหลด ${family} ${got.toFixed(1)} MB`),
  problem: {
    "few-rows-a": "คำฝั่ง A ยาวไป ตัวอักษรได้เส้นน้อย อ่านยาก ลองคำที่สั้นลง",
    "few-rows-b": "คำฝั่ง B ยาวไป ตัวอักษรได้เส้นน้อย อ่านยาก ลองคำที่สั้นลง",
    "light-body": "สีตัวที่รองแก้วควรเข้มกว่าสีข้อความ ไม่อย่างนั้นข้อความจะไม่เด่น",
    "thin-text": "ตัวอักษรบางมาก — บางเส้นอาจพิมพ์ไม่ติด ลองเพิ่มขนาดโลโก้หรือลดจำนวนตัวอักษร",
    "same-colour": "สีโลโก้เหมือนสีตัวที่รองแก้ว โลโก้จะมองไม่เห็น",
    "thin-parts": "โลโก้มีเส้นบางที่ติดกับส่วนหนา — สไลเซอร์อาจตัดทิ้ง",
    dropped: (p) => `ตัดชิ้นที่บางเกินพิมพ์ออกจากโลโก้ ${p.n} ชิ้น`,
    "all-thin": "โลโก้บางเกินไปสำหรับขนาดนี้ — ดาวน์โหลดไม่ได้",
    "art-too-complex": "โลโก้ซับซ้อนเกินไป — ดาวน์โหลดไม่ได้",
  },
  dlstl: "STL",
  copied: "คัดลอกแล้ว",
  fatal: "โหลดตัวคำนวณไม่สำเร็จ — ลองรีเฟรชหน้า",
  buildTimeout: "สร้างแบบไม่เสร็จใน 10 วินาที จึงเริ่มใหม่ — ลองลดตัวอักษรหรือเปลี่ยนฟอนต์",

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  beta: "รุ่นทดลอง",
  aboutH2: "ที่รองแก้วสองหน้าทำงานอย่างไร",
  aboutP1: "สันนูนบนที่รองแก้วซ่อนชั้นสีไว้ข้างใต้ คนที่นั่งฝั่ง A มองเห็นคำหนึ่ง คนที่นั่งฝั่งตรงข้ามเห็นอีกคำ มองจากด้านบนตรง ๆ จะไม่เห็นข้อความ จากการจำลอง อ่านได้ชัดที่สุดเมื่อวางห่างตัวประมาณ 40–100 ซม.",
  aboutP2: "พิมพ์ที่ความสูงชั้น 0.2 มม. ใช้สีตัวเข้มและสีข้อความสว่าง ร่องระหว่างสันช่วยไม่ให้แก้วเปียกติดที่รองแก้วและเก็บหยดน้ำไว้ เช็ดน้ำออกหลังใช้",
  aboutPrintNote: "แบบนี้ผ่านการจำลองแสงและการ slice แล้ว กำลังรอผลทดสอบพิมพ์จริง",
  aboutLogoP: "แบบ “ชื่อ / โลโก้” เป็นที่รองแก้วหน้าเรียบ ใส่ข้อความหรือไฟล์ SVG ของโลโก้ร้าน เลือกได้ทั้งแบบเรียบ นูน หรือเซาะร่อง ไฟล์โลโก้อยู่ในเครื่องของคุณ ไม่ถูกส่งไปที่ใด ข้อจำกัด: เส้นหรือช่องว่างระหว่างตัวอักษรที่แคบกว่าหัวพิมพ์อาจถูกสไลเซอร์ตัดทิ้งหรือพิมพ์ติดกัน ดูตัวอย่างในสไลเซอร์ก่อนพิมพ์ แบบนี้ผ่านการ slice ใน OrcaSlicer แล้ว ยังไม่ได้ทดสอบพิมพ์จริง",
  // the words a page opened with no link starts on (R69): today's, the document's defaults (src/doc.js DEFAULT_DOC)
  start: {
    a: "รักนะ",
    b: "LOVE",
  },
};
export default S;
